import React from 'react'
import { useLocation } from 'react-router-dom'

export function FocusManager() {
  const location = useLocation()
  React.useEffect(() => {
    const main = document.getElementById('main')
    if (main) {
      // Delay slightly to allow render
      setTimeout(() => {
        try { (main as HTMLElement).focus() } catch {}
      }, 0)
    }
  }, [location])
  return null
}

